import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import "./RecruitmentCardKam.css"
import {getResource, uploadFileResource} from "../../service/http-service";
import SelectOptionTwo from "../../ui/SelectOptionTwo";
import ModalFormSalariedKam from "./ModalFormSalariedKam";

export const ModalFormKam = ({type, title, externalRecruitmentId, lgShow, setLgShow, widthClass}) => {

  const [cities, setCities] = useState([])
  const [municipalities, setMunicipalities] = useState([])
  const [selectedFile, setSelectedFile] = useState(null);
  const [isFilePicked, setIsFilePicked] = useState(false);
  const [showError, setShowError] = useState(true);
  const [cursor, setCursor] = useState(false);

  const formData = new FormData();

  useEffect(() => {
    getResource('cities').then((data) => {
      setCities(data.data)
    })
    getResource('municipalities').then((data) => {
      setMunicipalities(data.data)
    })
  }, []);

  const [candidate, setCandidate] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    city: '',
    municipality: '',
    mail: '',
    description: '',
    isReferral: false,
    referralInfo: '',
    consent: false,
    externalRecruitmentId: externalRecruitmentId
  })

  const [emailError, setEmailError] = useState("");

  const validateEmail = (email) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  };
  useEffect(() => {
    // console.log("VLEZE VO 111", candidate)
    // formData.append("file", selectedFile);
    // formData.append("externalRecruitmentId", candidate.externalRecruitmentId);
    // formData.append("firstName", candidate.firstName);
    // formData.append("lastName", candidate.lastName);
    // formData.append("phone", candidate.phone);
    // formData.append("city", candidate.city);
    // formData.append("municipality", candidate.municipality);
    // formData.append("mail", candidate.mail);
    // formData.append("description", candidate.description);
    // formData.append("isReferral", candidate.isReferral);
    // formData.append("referralInfo", candidate.referralInfo);
    // formData.forEach((value, key) => {
    //     console.log("KEY:",key,"VALUE:", value);});

    if ((!candidate.firstName || candidate.firstName === '')
      || (!candidate.lastName || candidate.lastName === '')
      || (!candidate.city || candidate.city === '')
      || (!candidate.municipality || candidate.municipality === '') ||
      (!candidate.phone || candidate.phone === '')
      // || (!selectedFile || selectedFile === '')
      || (!candidate.isReferral || candidate.isReferral === false)
      || (!candidate.referralInfo || candidate.referralInfo === '')
      || (!candidate.consent || candidate.consent === false)) {
      setShowError(true);
      // console.log("VLEZE VO 22", candidate)
      return;
    } else if ((candidate.firstName || candidate.firstName !== '')
      || (candidate.lastName || candidate.lastName !== '')
      || (candidate.city || candidate.city !== '')
      || (candidate.municipality || candidate.municipality !== '')
      || (candidate.phone || candidate.phone !== '')
      // || (selectedFile || selectedFile !== '')
      || (candidate.isReferral || candidate.isReferral === true)
      || (candidate.referralInfo || candidate.referralInfo !== '')
      || (candidate.consent || candidate.consent === true)) {
      setShowError(false);
      // console.log("VLEZE VO 33", candidate)
    } else {
      // console.log("VLEZE VO 444", candidate)
      setShowError(false)
    }
  }, [candidate, selectedFile])

  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
    setIsFilePicked(true);
  };

  const clearFormFields = () => {
    setCandidate({
      externalRecruitmentId: externalRecruitmentId,
      firstName: '',
      lastName: '',
      phone: '',
      city: '',
      municipality: '',
      mail: '',
      description: '',
      isReferral: false,
      referralInfo: '',
      consent: false
    })
    setLgShow(false)
    setCursor(false)
  }


  const handleSubmission = () => {
    // Validation
    const isInvalid = !candidate.firstName ||
      !candidate.lastName ||
      !candidate.city ||
      !candidate.municipality ||
      !candidate.phone ||
      // !selectedFile ||
      !candidate.isReferral ||
      !candidate.referralInfo ||
      !candidate.consent;

    if (isInvalid) {
      setShowError(true);
      return;
    }

    setShowError(false);

    // Use a new FormData instance to avoid stale data
    const formData = new FormData();
    if (selectedFile != null) {
      formData.append("file", selectedFile);
    }
    formData.append("externalRecruitmentId", candidate.externalRecruitmentId);
    formData.append("firstName", candidate.firstName);
    formData.append("lastName", candidate.lastName);
    formData.append("phone", candidate.phone);
    formData.append("city", candidate.city);
    formData.append("municipality", candidate.municipality);
    formData.append("mail", candidate.mail);
    formData.append("description", candidate.description);
    formData.append("isReferral", candidate.isReferral);
    formData.append("consent", candidate.consent);
    formData.append("referralInfo", candidate.referralInfo);

    // Debug print of FormData
    // for (const [key, value] of formData.entries()) {
    //     console.log("KEY:", key, "VALUE:", value);
    // }

    // Upload
    uploadFileResource('candidates/add_candidate_document', formData)
      .then((data) => {
        console.log(data.data);
        setSelectedFile(null);
        clearFormFields();
        alert("Вашата апликација е успешно поднесена!");
      })
      .catch((exception) => {
        alert("Настана грешка при поднесувањето на апликацијата:\n" + exception.response.data.message);
      });
  };

  return (
    <>
      {type !== 3 ?
        <>
          <button className={widthClass} id="apply" onClick={() => setLgShow(true)}
          >Аплицирај
          </button>
          <Modal className={cursor === false ? 'disabled' : 'cursor_wait'}
                 size="lg"
                 show={lgShow}
                 onHide={clearFormFields}
                 aria-labelledby="example-modal-sizes-title-lg"
          >

            <>
              <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                  {title}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="inputs_container">
                  <div className="candidate_input">
                    <label>Име *</label>
                    <br/>
                    <input
                      className="candidate_data"
                      type="text"
                      placeholder="Внеси име..."
                      maxLength={15}
                      value={candidate.firstName}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^a-zA-Zа-шА-Ш\s]/g, ""); // allows letters (Latin/Cyrillic), numbers, and space
                        setCandidate({...candidate, firstName: value});
                      }}
                    />
                  </div>
                  <div className="candidate_input">
                    <label>Презиме *</label>
                    <br/>
                    <input
                      className="candidate_data"
                      type="text"
                      placeholder="Внеси презиме..."
                      maxLength={15}
                      value={candidate.lastName}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^a-zA-Zа-шА-Ш\s]/g, ""); // allows letters (Latin/Cyrillic), numbers, and space
                        setCandidate({...candidate, lastName: value});
                      }}
                    />
                  </div>
                  <div className="candidate_input">
                    <label>Телефон *</label>
                    <br/>
                    <input
                      className="candidate_data"
                      type="number"
                      placeholder="Внеси телефон..."
                      maxLength={15}
                      value={candidate.phone}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9+\s]/g, ""); // allows numbers, and +
                        setCandidate({...candidate, phone: value});
                      }}
                    />
                  </div>
                  <div className="candidate_input">
                    <label>Град *</label>
                    <br/>
                    {(cities && cities.length > 0) &&
                      <SelectOptionTwo
                        placeholder={"Внеси град..."}
                        value={candidate.city ? candidate.city : ""}
                        data={cities}
                        handleChange={(selectedOption) => {
                          setCandidate({
                            ...candidate,
                            city: selectedOption ? selectedOption.value : ""
                          })
                        }}
                      />
                    }
                  </div>
                  <div className="candidate_input">
                    <label>Општина *</label>
                    <br/>
                    {municipalities && municipalities.length > 0 && (
                      <SelectOptionTwo
                        placeholder={"Внеси општина..."}
                        value={candidate.municipality ? candidate.municipality : ""}
                        data={municipalities}
                        handleChange={(selectedOption) => {
                          setCandidate({
                            ...candidate,
                            municipality: selectedOption ? selectedOption.value : ""
                          });
                        }}
                      />
                    )}

                  </div>
                  <div className="candidate_input">
                    <label>E-mail</label>
                    <br/>
                    <>
                      <input
                        className="candidate_data"
                        type="email"
                        placeholder="Внеси e-mail..."
                        value={candidate.mail}
                        maxLength={50}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^a-zA-Z0-9@._%+-]/g, "");
                          setCandidate({...candidate, mail: value});

                          // Show message instantly
                          if (value && !validateEmail(value)) {
                            setEmailError("Внесете валидна e-mail адреса");
                          } else {
                            setEmailError("");
                          }
                        }}
                      />
                      {emailError && <span style={{color: "red"}}>{emailError}</span>}
                    </>
                  </div>
                </div>
                <div>
                  <br/>

                  <form
                    id="newDocForm"
                    className="d-flex justify-content-start"
                    // onSubmit={handleSubmit}
                    encType="multipart/form-data"
                  >
                    <br/>
                    <label className="w-25">Прикачи CV</label>
                    <input
                      type="file"
                      name="file"
                      onChange={changeHandler}
                    />
                  </form>
                </div>
                <div>
                  <label>Опиши се себеси</label>
                  <br/>
                  <textarea
                    className="candidate_textarea"
                    placeholder="Опиши се себеси..."
                    value={candidate.description}
                    maxLength={200}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^a-zA-Zа-шА-Ш0-9.,\s]/g, ""); // allows letters (Latin/Cyrillic), numbers, and space
                      setCandidate({...candidate, description: value});
                    }}
                  />
                  <div style={{
                    fontSize: "12px",
                    float: "right",
                    color: candidate.description.length >= 200 ? "red" : "#666"
                  }}>
                    {candidate.description.length}/200
                  </div>
                </div>
                <div className="referral">
                  <input type="checkbox" id="referral" name="referral"
                         value={candidate.isReferral}
                         onClick={(e) =>
                           setCandidate({...candidate, isReferral: !candidate.isReferral})}/>
                  <label htmlFor="referral"> * Препорачано од пријател</label>
                </div>
                {candidate.isReferral &&
                  <div>
                                <textarea
                                  className="candidate_textarea mt-2"
                                  type="text"
                                  placeholder="Препорачано од пријател (да се наведе име, презиме, работна позиција)..."
                                  maxLength={50}
                                  required
                                  value={candidate.referralInfo}
                                  onChange={(e) => {
                                    const value = e.target.value.replace(/[^a-zA-Zа-шА-Ш0-9.,\s]/g, "");
                                    setCandidate({...candidate, referralInfo: value});
                                  }}
                                />
                    <div style={{
                      fontSize: "12px",
                      float: "right",
                      color: candidate.referralInfo.length >= 50 ? "red" : "#666"
                    }}>
                      {candidate.referralInfo.length}/50
                    </div>
                  </div>}
                <div style={{marginTop: "15px"}}>
                  <input type="checkbox" id="consent" name="consent"
                         value={candidate.consent}
                         onClick={(e) => setCandidate({...candidate, consent: !candidate.consent})}/>
                  <label style={{display: "inline"}} htmlFor="consent"> * Давам изречна согласност КАМ доо
                    Илинден, да врши обработка на моите лични податоци,
                    како и да ги чува во збирката на лични податоци, за потребите на процесот на
                    регрутација на кадри во
                    Друштвото се додека има потреба од истите и да постапува со нив согласно Законот за
                    заштита на личните податоци и <a
                      href="https://kam.com.mk/politika-za-zashtita-na-licni-podatoci.nspx"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Политиката за заштита на лични податоци
                    </a>
                  </label>
                </div>
              </Modal.Body>
              <Modal.Footer closeButton>
                {showError &&
                  <small className="color_red">Ве молиме пополнете ги задолжителните * полиња</small>}
                <div
                  type="button"
                  className={`btn_apply_form ${((!candidate.firstName)
                    || (!candidate.lastName)
                    || (!candidate.city)
                    || (!candidate.municipality)
                    || (!candidate.phone)
                    // || (!selectedFile)
                    || (!candidate.isReferral)
                    || (!candidate.referralInfo)
                    || (!candidate.consent)) ? 'disabled' : ''}`}
                  onClick={(e) => handleSubmission()}
                  disabled={(!candidate.firstName)
                    || (!candidate.lastName)
                    || (!candidate.city)
                    || (!candidate.municipality)
                    || (!candidate.phone)
                    // || (!selectedFile)
                    || (!candidate.isReferral)
                    || (!candidate.referralInfo)
                    || (!candidate.consent)}
                >
                  Аплицирај
                </div>
              </Modal.Footer>
            </>

          </Modal>
        </>
        :
        <ModalFormSalariedKam type={type} externalRecruitmentId={externalRecruitmentId} title={title} lgShow={lgShow}
                              widthClass={widthClass}/>
      }
    </>
  );

}

export default ModalFormKam;
